import { createToolStore } from './create-tool-store'

export const useVideoCompressorStore = createToolStore({ quality: 50 })
